// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"widget_formContainer__fdaV0","nflRflz":"widget_nflRflz__FNH47","nflFlepz":"widget_nflFlepz__PwCrO"};